import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutocompleteComponent } from './autocomplete.component';
import { ReactiveFormsModule } from '@angular/forms';
import {
  AutocompleteContainerTemplateDirective,
  AutocompleteFooterTemplateDirective,
  AutocompleteHeaderTemplateDirective,
  IsEllipsisActiveDirective,
} from './autocomplete.directive';
import { HighlightModule } from '../../pipes/highlight/highlight.module';
import { RxPleaseWaitCircleModule } from '../please-wait-circle/please-wait-circle.module';
import { RxInputModule } from '../input/input.module';
import { ClickOutsideModule } from '../../directives';

@NgModule({
  imports: [CommonModule, RxPleaseWaitCircleModule, RxInputModule, ReactiveFormsModule, ClickOutsideModule, HighlightModule],
  declarations: [
    AutocompleteComponent,
    AutocompleteHeaderTemplateDirective,
    AutocompleteContainerTemplateDirective,
    AutocompleteFooterTemplateDirective,
    IsEllipsisActiveDirective,
  ],
  exports: [AutocompleteComponent, AutocompleteFooterTemplateDirective],
})
export class AutocompleteModule {}
